module.exports = __webpack_public_path__ + "img/Weapon_12.0bef3146.png";